import { FC } from 'react';
import { format, isWeekend } from 'date-fns';
import { merge } from '@/helpers/Utility';
import { DateRadioPickerButton } from './DateRadioPickerButton';
import { DateRadioPickerOption } from './dateRadioPicker.types';

interface DateRadioPickerDayProps {
  date: Date;
  options: DateRadioPickerOption[];
  onSelect: (newOption?: DateRadioPickerOption) => void;
  selectedOption?: DateRadioPickerOption;
}

export const RosterBusyPickerHeight = 'h-[70px]';
export const RosterBusyHeaderHeight = 'h-[50px]';

export const DateRadioPickerDay: FC<DateRadioPickerDayProps> = ({ date, options, onSelect, selectedOption }) => {
  return (
    <div className="border-r last:border-0">
      <div
        className={merge(
          'flex flex-col items-center justify-center font-bold text-gray-500 border-b',
          RosterBusyHeaderHeight,
          isWeekend(date) ? 'text-green-500' : ''
        )}
      >
        <p>{format(date, 'E').charAt(0)}</p>
        <p>{`${date.getDate()}/${date.getMonth() + 1}`}</p>
      </div>
      {options.map(opt => (
        <DateRadioPickerButton
          isActive={selectedOption?.value === opt.value}
          className={'border-b'}
          onSelect={() => onSelect(opt)}
          optionColor={opt.color}
        />
      ))}
    </div>
  );
};
